<template>
  <div class="search">
    <div class="selecttype" style="margin-right: 20px;">
      <el-dropdown @command="handleCommand" style="width: 100%;">
        <span class="el-dropdown-link xiala">
          {{typename =='collegescore'?'院校优先':'专业优先'}}<i class="el-icon-arrow-down el-icon--right"></i>
         </span>
        <el-dropdown-menu slot="dropdown" class="xialadeng">
          <el-dropdown-item command="collegescore">院校优先</el-dropdown-item>
          <el-dropdown-item command="majorscore">专业优先</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="selecttype"  style="width: 180px;">
      <el-dropdown @command="handleCommandbatch" style="width: 100%;">
        <span class="el-dropdown-link xiala" style="padding-left: 40px;padding-right: 0;">
          {{batchname}}<i class="el-icon-arrow-down el-icon--right"></i>
         </span>
        <el-dropdown-menu slot="dropdown" class="xialadeng" style="width: 180px;">
          <el-dropdown-item :command="index" :key="item.provincialId" v-for="(item,index) in pickerValueArray">{{item.provincialBatch}}  {{item.provincialScore}}分</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="serachkuang">
      <input placeholder="请输入您想查询的院校" v-model="name"  @keydown.enter="search"/>
    </div>
    <div class="serachkuang">
      <input placeholder="请输入您想查询的专业" v-model="major"  @keydown.enter="search"/>
    </div>
    <div class="sousuo" @click="search">
      查询
    </div>
  </div>
</template>
<script>
  export default {
    props: ['pickerValueArray','batch'],
    components: {},
    data() {
      return {
        name:'',
        major:'',
        typename:'collegescore',
        batchname:'省控线'
      };
    },
    computed: {

    },
    watch:{
      pickerValueArray(vl){
        if(vl.length!=0){
          this.batchname =vl[0].provincialBatch
        }
      },
      batch(vl){
        if(vl!=null&&vl!=''){
          this.batchname =vl
        }
      },

    },
    created() {
    },
    methods: {
      setname(obj){
        console.log(245324)
        this.name = obj.name
        this.major = obj.major
      },
      search(){
        let obj = {
          typename:this.typename,
          batchname:this.batchname,
          collegename:this.name,
          majorname:this.major,
        }
        this.$emit("search",obj)
      },
      clear(){
        this.name = ''
      },
      handleCommand(i){
       this.typename = i;
       this.search()
      },
      handleCommandbatch(i){
       this.batchname = this.pickerValueArray[i].provincialBatch;
       this.$utils.setlocalStorage("userZhiYuanBatch",this.pickerValueArray[i])
       this.search()
      }
    },
    mounted() {},
  };
</script>
<style scoped>
  .selecttype{
    width: 140px;
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    border-radius: 6px;
  }
  .xiala{
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    padding-left: 35px;
    padding-right: 20px;
  }
  .sousuo {
    width: 100px;
    background-color: #f00;
    color: #fff;
    margin-left: 20px;
    font-size: 20px;
    border-radius: 6px;
    font-weight: 800;
    height: 40px;
    text-align: center;
    line-height: 36px;
  }
  .sousuo img {
    padding: 15px 9px 15px;
    background: red;
    width: 50px;
    height: 50px;
    border-radius: 6px;
  }

  .serachkuang input {
    border: none;
    width: 230px;
    height: 40px;
    background: #fff;
    opacity: 1;
    border-radius: 6px;
    margin-left: 15px;
    padding-left: 15px;
  }

  ::-webkit-input-placeholder {
    color: #999999;
  }

  .serachkuang {
    display: flex;
    height: 100%;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  .search {
    width: 100%;
    height: 100%;
    margin-top: 70px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: url(../../src/assets/img/title.icon1.png);
    width: 100%;
    height: 140px;
  }

.xialadeng {
    width: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .el-dropdown-menu__item {
    width: 100%;
    text-align: center;
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    border: none !important;
    background-color: #F53824 !important;
    color: #FFFFFF;
  }

  .el-dropdown {
  }


  .el-dropdown-link {
    cursor: pointer;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

</style>



// WEBPACK FOOTER //
// src/components/vSerchfen.vue